import { apiRequest, DataReturnType, HttpMethods, LeadGetDTO } from "@alba-cars/common-modules";

interface GetOrCreateLeadInput {
  name: string;
  phone: string;
  source?: "car-booking" | "sell-car" | "bank-finance" | "bank-valuation" | "test-drive" | "showroom-visit" | "other";
  status?: "NEW" | "CONTACTED" | "QUALIFIED" | "NEGOTIATING" | "CLOSED_WON" | "CLOSED_LOST" | "ABANDONED_FORM";
  webhookData?: Record<string, any>;
}

export const getOrCreateLead = async (data: GetOrCreateLeadInput) => {
  const endpoint = `/leads/get-or-create`;

  const response = await apiRequest<DataReturnType<LeadGetDTO> & { isNew: boolean }>(endpoint, {
    method: HttpMethods.POST,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  return response;
};
